//
// JRedirect.js
//

function JRedirect(data) {
    const {type, url} = data?.JTurn?.JRedirect ?? {};

    if (!type || !url) {
        return;
    }

    window.open(url, type);
}

// Make available globally
window.JRedirect = JRedirect;